import { render } from "./CellValue.vue?vue&type=template&id=01671931&scoped=true"
import script from "./CellValue.vue?vue&type=script&lang=js"
export * from "./CellValue.vue?vue&type=script&lang=js"

import "./CellValue.vue?vue&type=style&index=0&id=01671931&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01671931"]])

export default __exports__